import { useParams } from 'react-router-dom';
import React, { useState, useEffect,useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { ROUTES, USER_ROLES, USERS_ROLE } from "../../../utilities/constant";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { API_INCOMING_SUMMARY_LIST, DOWNLOAD_REPORT, API_INCOMING_REPORT_BY_DID_LIST } from '../../../service/url';
import { getApiCall } from '../../../service/getApiCall';
import { formatDateTime } from '../../../utilities/helpers';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { PhoneIncoming, PhoneOutgoing } from "lucide-react";
import '../../../assets/custom/css/tabs.css'
import AsyncStorage from '@react-native-async-storage/async-storage';


const DidDetailPage = () => {

  const audioRefs = useRef({});
  const toNum = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const isConnected = (call) => toNum(call?.billing_duration) > 0;
  const hasRung = (call) => (toNum(call?.bridge_ring_duration) > 0) || (toNum(call?.ring_duration) > 0);

  const statusStyles = {
    success: {
      backgroundColor: "rgba(0, 128, 0, 0.1)",
      color: "#006400",
      width: "85px",
      padding: "4px 10px",
      borderRadius: "4px",
      textAlign: "center",
      margin: 0
    },
    failed: {
      backgroundColor: "rgba(255, 0, 0, 0.1)",
      color: "#b00000",
      width: "75px",
      padding: "4px 10px",
      borderRadius: "4px",
      textAlign: "center",
      margin: 0
    },
    failedAbsolute: {
      backgroundColor: "rgba(255, 0, 0, 0.1)",
      color: "#b00000",
      width: "60px",
      padding: "4px 10px",
      borderRadius: "4px",
      position: "absolute",
      top: "70px"
    },
    successAbsolute: {
      backgroundColor: "rgba(0, 128, 0, 0.1)",
      color: "#006400",
      width: "85px",
      padding: "4px 10px",
      borderRadius: "4px",
      position: "absolute",
      top: "70px"
    }
  };

  // Decide Success/Failed from billable duration.
  // Requirement: if `billing_duration > 0` then always show "Success".
  const isSuccessByBillingDuration = (row) =>
    Number(row?.billing_duration || 0) > 0;
  const { did, startDate, endDate } = useParams();
  const [incomingReport, setIncomingReport] = useState([]);
  const [detailStartDate, setDetailStartDate] = useState(startDate);
  const [detailEndDate, setDetailEndDate] = useState(endDate);
  const [detailStartTime, setDetailStartTime] = useState(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  });
  const [detailEndTime, setDetailEndTime] = useState(() => {
    const date = new Date();
    date.setHours(23, 59, 0, 0);
    return date;
  });

  const [playingId, setPlayingId] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [selectedCall, setSelectedCall] = useState([]);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [statusDialogVisible, setStatusDialogVisible] = useState(false);
  const [statusDialogCall, setStatusDialogCall] = useState(null);



  const [mainCall, setMainCall] = useState(null); // for clicked one
  const [relatedCalls, setRelatedCalls] = useState([]); // others with same trace_id


  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const rawUser = await AsyncStorage.getItem('user');
      if (!rawUser) {
        console.error("User data not found in AsyncStorage");
        return;
      }
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in AsyncStorage user:", e);
        return;
      }
      setUserRole(user?.role);
    };
    fetchUserData()
  }, [])


  const fetchIncomingReport = (start, end, startTime, endTime) => {
    const startMoment = moment(start);
    const endMoment = moment(end);

    const startTimeMoment = moment(startTime);
    const endTimeMoment = moment(endTime);

    const formattedStart = startMoment
      .hour(startTimeMoment.hour())
      .minute(startTimeMoment.minute())
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");

    const formattedEnd = endMoment
      .hour(endTimeMoment.hour())
      .minute(endTimeMoment.minute())
      .second(59)
      .format("YYYY-MM-DD HH:mm:ss");

    getApiCall(`${API_INCOMING_REPORT_BY_DID_LIST}/${did}/${formattedStart}/${formattedEnd}`).then((data) => {
      setIncomingReport(data);
    })
      .catch(err => console.log(err));
  };



  useEffect(() => {
    fetchIncomingReport(detailStartDate, detailEndDate, detailStartTime, detailEndTime);
  }, [did, detailStartDate, detailEndDate, detailStartTime, detailEndTime]);

  const handleDetailFilter = () => {
    fetchIncomingReport(detailStartDate, detailEndDate, detailStartTime, detailEndTime);
  };

  const handleDetailClearFilter = () => {
    setDetailStartDate(startDate);
    setDetailEndDate(endDate);
    const resetStart = new Date();
    resetStart.setHours(0, 0, 0, 0);
    const resetEnd = new Date();
    resetEnd.setHours(23, 59, 0, 0);
    setDetailStartTime(resetStart);
    setDetailEndTime(resetEnd);
    fetchIncomingReport(startDate, endDate, resetStart, resetEnd);
  };

  const handlePlayPause = (id) => {
  const current = audioRefs.current[id];

  if (playingId && playingId !== id) {
    audioRefs.current[playingId]?.pause();
    audioRefs.current[playingId].currentTime = 0;
  }

  if (playingId === id) {
    current.pause();
    setPlayingId(null);
  } else {
    current.play();
    setPlayingId(id);
  }
};

  const openStatusDialog = (call) => {
    setStatusDialogCall(call);
    setStatusDialogVisible(true);
  };

  const statusPill = (call) => {
    const connected = isConnected(call);
    const style = connected ? statusStyles.success : statusStyles.failed;

    return (
      <div
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          cursor: "default",
          userSelect: "none",
          border: "1px solid rgba(0,0,0,0.06)",
          width: "100%",
          color: "white",
        }}
      >
        <span style={{ fontWeight: 600 }}>
          {connected ? "Connected" : "Failed"}
        </span>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openStatusDialog(call);
          }}
          style={{
            border: "none",
            background: "transparent",
            padding: 0,
            margin: 0,
            lineHeight: 1,
            cursor: "pointer",
            color: connected ? "#006400" : "#b00000",
          }}
          aria-label="View call events"
          title="View call events"
        >
          <i className="fa fa-info-circle" aria-hidden="true" />
        </button>
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    const hasRecording = !!rowData.recording_file;

    const handleViewClick = async () => {
      if (!rowData.trace_id) {
        console.warn("Trace ID is missing");
        return;
      }

      const start = encodeURIComponent(rowData.start_time);
      const end = encodeURIComponent(rowData.end_time);
      const did = encodeURIComponent(rowData.callee_number);
      const trace_id = encodeURIComponent(rowData.trace_id);

      try {
        const response = await getApiCall(
          `${API_INCOMING_REPORT_BY_DID_LIST}/${did}/${start}/${end}/${trace_id}`
        );

        const incoming = response?.incomingReports || [];
        const outbound = response?.outboundReports || [];

        let main;
        let rest;

        if (userRole === USER_ROLES.CALL_CENTRE_AGENT) {
          main = outbound.find(d => d.id === rowData.id);
          rest = incoming
        } else {
          main = incoming.find(d => d.id === rowData.id);
          rest = outbound;
        }

        setMainCall(main);
        setRelatedCalls(outbound);
        setShowSidePanel(true);
      } catch (err) {
        console.log(err);
      }
    };

    return (
      <>
        <button
          className="btn-icons m-1"
          onClick={handleViewClick}
          style={{ border: "none", background: "none", padding: "0" }}
        >
          <i
            className="fa fa-eye"
            aria-hidden="true"
            style={{ color: "blue", fontSize: "18px" }}
          ></i>
        </button>


        {hasRecording ? (
          <>
            <button
              className="btn-icons m-1"
              onClick={() => handlePlayPause(rowData.id)}
              style={{ border: "none", background: "none", padding: "0", position:'relative' }}
            >
              {playingId === rowData.id ? (
                // Pause icon
                <svg width="25" height="25" viewBox="0 0 24 24" style={{ color: 'blue',position:'absolute', bottom:"-5.5px", left:"-4px" }}>
                  <path
                    d="M6 5h4v14H6zM14 5h4v14h-4z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <svg width="25" height="25" viewBox="0 0 24 24" style={{ color: 'blue',position:'absolute', bottom:"-5.5px", left:"-4px" }}>
                  <path
                    d="M8 5v14l11-7z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>
            <audio
              ref={(el) => (audioRefs.current[rowData.id] = el)}
              src={rowData.recording_file}
            />
          </>
        ) : (
          null
        )}
      </>
    );
  };




  return (
    <div>
      <div className="card" style={{ marginTop: "20px" }} >
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title m-0">DID Detail View</h4>
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/${ROUTES.IVR.INCOMING_SUMMARY}`)}
            style={{ marginRight: '10px' }}
          >
            {userRole === USER_ROLES.CALL_CENTRE_AGENT ? "Back to Outbound Summary" : "Back to Incoming Summary"}
          </button>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center mb-3" style={{ marginLeft: "10px" }}>
            <Calendar
              value={detailStartTime}
              onChange={(e) => setDetailStartTime(e.value)}
              placeholder="Start Time"
              timeOnly
              showIcon
            />
            <span className="mx-2">to</span>
            <Calendar
              value={detailEndTime}
              onChange={(e) => setDetailEndTime(e.value)}
              placeholder="End Time"
              timeOnly
              showIcon
            />
            <Button
              label="Filter"
              onClick={handleDetailFilter}
              className="p-button-sm p-button-primary mx-2"
            />
            <Button
              label="Reset"
              onClick={handleDetailClearFilter}
              className="p-button-sm p-button-secondary"
            />
          </div>
          <div className="scroll-container">
            <DataTable value={incomingReport} paginator rows={10} tableStyle={{ minWidth: "50rem" }}>
              <Column field="user_id" header="User Id" />
              <Column field="caller_number" header="Caller Number" />
              <Column field="callee_number" header="Callee Number" />
              <Column field="start_time" header="Start Time" body={(rowData) => formatDateTime(rowData.start_time)} />
              <Column field="end_time" header="End Time" body={(rowData) => formatDateTime(rowData.end_time)} />
              <Column header="Trace ID" body={(rowData) => rowData.trace_id || "-"} />
              <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
          </div>
        </div>
      </div>
      {/* <ToastNotification
            show_toast={showToast}
            set_show_toast={setShowToast}
            {...toastProps}
          />
          <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
            <Modal.Body className="text-center">
              <h5>{toastMessage}</h5>
              <LottieAnimation animationData={"https://assets6.lottiefiles.com/packages/lf20_touohxv0.json"} />
            </Modal.Body>
          </Modal> */}



      {showSidePanel && (
        <div
          
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(2px)',
            zIndex: 1045,
          }}
          onClick={() => setShowSidePanel(false)}
        />
      )}

      <Dialog
        header="Call Events Details"
        visible={statusDialogVisible}
        onHide={() => setStatusDialogVisible(false)}
        style={{ width: "720px", maxWidth: "94vw" }}
        draggable={false}
        resizable={false}
      >
        {statusDialogCall ? (
          <div>
            {(() => {
              const connected = isConnected(statusDialogCall);
              const ringOk = hasRung(statusDialogCall);

              const okColor = "#16a34a";
              const badColor = "#dc2626";
              const lineColor = "#cbd5e1";

              const steps = [
                {
                  key: "initiated",
                  title: "Call Initiated",
                  ok: true,
                  detail: `Start: ${formatDateTime(statusDialogCall.start_time)}`,
                },
                {
                  key: "ring",
                  title: "Ring",
                  ok: ringOk,
                  detail: `Ring For: ${toNum(statusDialogCall.bridge_ring_duration || statusDialogCall.ring_duration)} sec`,
                },
                {
                  key: "connected",
                  title: "Connected",
                  ok: connected,
                  detail: `Connected For: ${toNum(statusDialogCall.billing_duration)} sec`,
                },
                {
                  key: "hangup",
                  title: "Hangup",
                  ok: true,
                  detail: `End: ${formatDateTime(statusDialogCall.end_time)}`,
                },
              ];

              return (
                <>
                  <div
                    style={{
                      padding: "12px 14px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                      marginBottom: "14px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
                      <div>
                        <div style={{ fontWeight: 800, fontSize: "14px" }}>
                          {statusDialogCall.caller_number || "-"} → {statusDialogCall.callee_number || "-"}
                        </div>
                        <div style={{ fontSize: "12px", marginTop: "2px" }}>
                          Call SID: {statusDialogCall.call_sid || "-"} • Trace ID: {statusDialogCall.trace_id || "-"}
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: 800,
                          padding: "6px 12px",
                          borderRadius: "999px",
                          background: connected ? "rgba(22,163,74,0.10)" : "rgba(220,38,38,0.10)",
                          color: connected ? okColor : badColor,
                          border: `1px solid ${connected ? "rgba(22,163,74,0.20)" : "rgba(220,38,38,0.20)"}`,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {connected ? "Connected" : "Failed"}
                      </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginTop: "12px" }}>
                      <div style={{ fontSize: "12px" }}>
                        <div style={{ fontWeight: 800 }}>Start</div>
                        <div>{formatDateTime(statusDialogCall.start_time)}</div>
                      </div>
                      <div style={{ fontSize: "12px"  }}>
                        <div style={{ fontWeight: 800 }}>End</div>
                        <div>{formatDateTime(statusDialogCall.end_time)}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      padding: "14px",
                      borderRadius: "12px",
                    }}
                  >
                    <div style={{ fontWeight: 900, marginBottom: "12px" }}>
                      Event Timeline
                    </div>

                    {steps.map((step, index) => {
                      const color = step.ok ? okColor : badColor;
                      return (
                        <div key={step.key} style={{ display: "flex", gap: "12px" }}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div
                              style={{
                                width: "14px",
                                height: "14px",
                                borderRadius: "999px",
                                background: color,
                                boxShadow: "0 0 0 4px rgba(2,6,23,0.04)",
                              }}
                            />
                            {index < steps.length - 1 ? (
                              <div style={{ width: "2px", flex: 1, background: lineColor, marginTop: "6px" }} />
                            ) : null}
                          </div>

                          <div style={{ paddingBottom: index < steps.length - 1 ? "16px" : 0, width: "100%" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                              <div style={{ fontWeight: 900 }}>{step.title}</div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 900,
                                  padding: "4px 10px",
                                  borderRadius: "999px",
                                  background: step.ok ? "rgba(22,163,74,0.10)" : "rgba(220,38,38,0.10)",
                                  color: step.ok ? okColor : badColor,
                                  border: `1px solid ${step.ok ? "rgba(22,163,74,0.20)" : "rgba(220,38,38,0.20)"}`,
                                }}
                              >
                                {step.ok ? "OK" : "FAILED"}
                              </div>
                            </div>
                            <div style={{ marginTop: "4px", fontSize: "12px" }}>{step.detail}</div>
                          </div>
                        </div>
                      );
                    })}

                    {/* <div
                      style={{
                        marginTop: "10px",
                        paddingTop: "10px",
                        borderTop: "1px dashed #e2e8f0",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                      }}
                    >
                      <div style={{ fontSize: "12px", color: "#475569" }}>
                        <div style={{ fontWeight: 900, color: "#0f172a" }}>patch_duration</div>
                        <div>{toNum(statusDialogCall.patch_duration)} sec</div>
                      </div>
                      <div style={{ fontSize: "12px", color: "#475569" }}>
                        <div style={{ fontWeight: 900, color: "#0f172a" }}>hangup_cause</div>
                        <div>{statusDialogCall.hangup_cause || "-"}</div>
                      </div>
                    </div> */}
                  </div>
                </>
              );
            })()}
          </div>
        ) : null}
      </Dialog>

      <div
        className="custom-scrollbar-panel"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: showSidePanel ? 'translate(-50%, -50%)' : 'translate(-50%, -150%)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1050,
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          width: '70%',
          maxHeight: '70%',
          overflowY: 'auto',
          padding: '20px',
          display: showSidePanel ? 'block' : 'none',
        }}
      >

        {showSidePanel && (mainCall || relatedCalls.length > 0) && (
          <>
            {/* FIXED CALL INFO SECTION */}

            <div  >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h5>Call Information</h5>
                <button
                  onClick={() => setShowSidePanel(false)}
                  style={{
                    border: 'none',
                    background: 'transparent !important',
                    borderRadius: '4px',
                    padding: '4px 8px',
                  }}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              {mainCall && (
                <div style={{ marginBottom: '20px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
                  <h3>{mainCall.callee_number}</h3>
                  <div style={{ display: 'flex', gap: '60px', marginTop: '20px' }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <p>Call Sid:</p>
                      <p>Trace ID:</p>
                      <p>Start Date:</p>
                      <p>End Date:</p>
                      <p>Caller Number:</p>
                      {/* <p>Agent Name:</p>
              <p>Agent Number:</p> */}
                      {/* <p>Call Group Name:</p> */}
                      <p>Answer Status:</p>
                      <p>Recording:</p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <p>{mainCall.call_sid}</p>
                      <p>{mainCall.trace_id}</p>
                      <p>{formatDateTime(mainCall.start_time)}</p>
                      <p>{formatDateTime(mainCall.end_time)}</p>
                      <p>{mainCall.caller_number}</p>
                      {/* <p>{mainCall.agent_name}</p>
              <p>{mainCall.agent_number}</p> */}
                      {/* <p>{mainCall.queue_name}</p> */}
                      {/* <p>{mainCall.queue_name}</p> */}
                      <div>{statusPill(mainCall)}</div>
                      {mainCall.recording_file ? (
                        <audio controls style={{ width: '100%', height: '30px' }}>
                          <source src={`https://your-cdn-path/${mainCall.recording_file}`} type="audio/wav" />
                          Your browser does not support the audio element.
                        </audio>
                      ) : <p style={{ marginTop: "10px" }}>Not Available</p>}
                    </div>
                  </div>
                </div>
              )}
            </div>



            <div >
              <div style={{ display: "flex", gap: "50px", padding: "10px" }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <PhoneIncoming size={18} color="green" strokeWidth={2.5} />
                  Incoming Call
                </h5>
                <h5 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <PhoneOutgoing size={18} color="blue" strokeWidth={2.5} />
                  Outbound Call
                </h5>
              </div>

              {showSidePanel && (
                <div style={{ marginTop: '20px', overflow: "auto", }} className="my-data-table" >
                  <DataTable
                    value={[mainCall, ...relatedCalls.filter(c => c.trace_id === mainCall.trace_id)]}
                    tableStyle={{ minWidth: "100rem" }}
                  >
                    <Column
                      header=""
                      body={(rowData) =>
                        rowData.call_sid === mainCall.call_sid ? (
                          <PhoneIncoming size={18} color="green" strokeWidth={2.5} />
                        ) : (
                          <PhoneOutgoing size={18} color="blue" strokeWidth={2.5} />
                        )
                      }
                      style={{ width: '3rem' }}
                    />
                    <Column field="call_sid" header="Call SID" />
                    <Column field="caller_number" header="Caller Number" />
                    <Column field="callee_number" header="Callee Number" />
                    <Column
                      header="Answer Status"
                      body={(row) => statusPill(row)}
                    />
                    <Column field="start_time" header="Start Time" body={(row) => formatDateTime(row.start_time)} />
                    <Column field="end_time" header="End Time" body={(row) => formatDateTime(row.end_time)} />
                    <Column field="billing_duration" header="Billing Duration" />
                    <Column field="patch_duration" header="Patch Duration" />
                    {/* <Column field="bridge_ring_duration" header="Ring Duration" /> */}
                  </DataTable>
                </div>
              )}
            </div>


            {/* RELATED CALLS TABLE WRAPPER */}

            <div style={{ overflow: "auto" }} className="my-data-table" >
              {relatedCalls.length > 0 && (
                <>
                  <h5 style={{ marginTop: '30px', marginLeft: "10px" }}>Related Calls</h5>
                  <div
                    style={{
                      marginTop: '20px',
                      width: '100%',
                      paddingBottom: '10px',
                    }}
                  >
                    <DataTable value={relatedCalls} paginator rows={5} tableStyle={{ minWidth: '1500px' }}>
                      <Column field="call_sid" header="Call SID" />
                      <Column field="caller_number" header="Caller Number" />
                      <Column field="agent_name" header="Agent Name" />
                      <Column field="agent_number" header="Agent Number" />
                      <Column
                        field="start_time"
                        header="Start Time"
                        body={(row) => formatDateTime(row.start_time)}
                      />
                      <Column
                        field="end_time"
                        header="End Time"
                        body={(row) => formatDateTime(row.end_time)}
                      />
                      <Column
                        header="Answer Status"
                        body={(row) => statusPill(row)}
                      />
                      <Column field="patch_duration" header="Patch Duration (sec)" />
                      <Column field="billing_duration" header="Billing Duration (sec)" />
                      <Column field="total_hold_duration" header="Hold Duration (sec)" />
                      <Column
                        header="Recording"
                        body={(row) =>
                          row.recording_file ? (
                            <audio controls style={{ height: '30px' }}>
                              <source src={`https://your-cdn-path/${row.recording_file}`} type="audio/wav" />
                            </audio>
                          ) : "-"
                        }
                      />
                    </DataTable>


                  </div>
                </>
              )}
            </div>

          </>
        )}



      </div>




    </div>
  );
};

export default DidDetailPage;
